<template>
  <div id="LearnEachLessonPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="گزارش یادگیری هر درس"></ActionBar>
    <div class="container mx-auto no-gutters  mt-2">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب سال:</span></div>
          <v-select
              v-model.number="selectedYear"
              :items="years"
              class="input-border"
              dense
              hide-details
              placeholder="انتخاب سال"
              solo
              @change="setYear">
          </v-select>
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب ماه:</span></div>
          <v-select
              ref='monthPicker'
              v-model.number="selectedMonth"
              :disabled="!showMonthPicker"
              :items="months"
              :menu-props="{value:openMonthPicker}"
              class="input-border"
              dense
              hide-details
              item-text="text"
              item-value="id"
              placeholder="انتخاب ماه"
              solo
              @change="setDate"
              @click="openMonthPicker  = true">
          </v-select>
        </div>
        <div class="col-8 col-sm-4 col-md-3 ">
          <div><i class="fas fa-chalkboard-teacher pl-1"></i><span class="font12px">کلاس:</span></div>
          <v-autocomplete
              v-model="classId"
              :items="classesItems"
              class="input-border"
              color="white"
              dense
              hide-details
              item-text="Text"
              item-value="Value"
              solo></v-autocomplete>
        </div>
        <div class="col-6 col-sm-4 col-md-1 text-left align-self-end">
          <v-btn :disabled="classId === null || selectedMonth === null || selectedYear===null" block class="px-8"
                 color="primary" rounded @click="search">
            جستجو
          </v-btn>
        </div>
      </div>
      <div class="row  mx-auto no-gutters p-0 mt-10">
        <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
          در حال جستجو
          <v-progress-linear
              color="deep-purple accent-4"
              height="6"
              indeterminate
              rounded
          ></v-progress-linear>
        </div>
        <div v-else-if="isLoaded" class="col-12 p-0 p-md-5  mx-auto ">
          <div v-if="!hasReport" class="mx-2 mt-5">
            <div class="col-12">
              <v-alert
                  border="bottom"
                  class="text-center"
                  color="forth"
                  dark>
                گزارشی برای تاریخ انتخاب شده وجود ندارد.
              </v-alert>
            </div>
          </div>
          <div v-else>
            <PlanetChart v-if="isChartLoaded"
                         :chart-data="loadChartData()"
                         :chart-line-slop-data="loadChartSlopData()"
                         :chartLabel="loadChartLabel()"
                         :label-line1="'میزان یادگیری درس'"
                         :label-line2="'میانگین'"/>

            <div class="col-12 mt-10">
              <v-alert
                  border="bottom"
                  class="text-center"
                  outlined
                  type="warning"
              >
                برای هفته هایی که در نمودار وجود ندارد گزارشی ثبت نشده است.
              </v-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMenu/>
  </div>
</template>

<script>

import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import PlanetChart from "../../components/PlanetChart";
import moment from "jalali-moment";

export default {
  name: "LearnEachLesson",
  metaInfo: {
    title: 'مسیربرتر-گزارش یادگیری هر درس'
  },
  components: {PlanetChart, FooterMenu, ActionBar},
  data: () => ({
    openMonthPicker: false,
    showMonthPicker: false,
    years: [],
    selectedYear: null,
    classesItems: [],
    classId: null,
    startDate: null,
    endDate: null,
    selectedMonth: null,
    months: [
      {id: 1, text: 'فروردین'},
      {id: 2, text: 'اردیبهشت'},
      {id: 3, text: 'خرداد'},
      {id: 4, text: 'تیر'},
      {id: 5, text: 'مرداد'},
      {id: 6, text: 'شهریور'},
      {id: 7, text: 'مهر '},
      {id: 8, text: 'آبان '},
      {id: 9, text: 'آذر '},
      {id: 10, text: 'دی'},
      {id: 11, text: 'بهمن'},
      {id: 12, text: 'اسفند '},
    ],
    dataLoading: false,
    isChartLoaded: false,
    isLoaded: false,
    hasReport: false,
    chartAvgData: [],
    chartLineSlopData: [],
    chartLabel: []


  }),
  mounted() {
    let year = this.$convertDate((new Date()).toISOString()).slice(0, 4)
    this.years.push(year - 1, parseInt(year))
    this.getLessons()

  },
  methods: {
    getWeekOfDate(date) {
      moment.locale('fa');
      let startDate = moment(date).startOf('month').date();
      let endDate = moment(date).date();
      let weekCount = 1;

      for (let i = startDate; i <= endDate; i++) {
        if (
            moment(date).date(i).format('dddd') ===
            moment().startOf('week').format('dddd')
        ) {
          weekCount++;
        }
      }
      return weekCount;
    },
    setYear() {
      this.showMonthPicker = true
      // this.openMonthPicker = true
    },
    setDate() {
      this.openMonthPicker = null

      this.startDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).startDate
      this.endDate = this.$chooseMonth(this.selectedMonth, this.selectedYear).endDate

    },
    search() {
      this.dataLoading = true;
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate", this.startDate);
      urlencoded.append("EndDate", this.endDate);
      urlencoded.append("LessonsFunID", this.classId);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_LearnEachLesson", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            json.sort((b, a) => a.ModifiedDate.localeCompare(b.ModifiedDate))
            this.isLoaded = true
            if (json.length > 0) {

              for (let i = 0; i < json.length; i++) {
                let jalaliDate = this.$convertDate(json[i].ModifiedDate)
                json[i].weekNumber = this.getWeekOfDate(jalaliDate)
              }

              let firstWeek = json.filter(x => x.weekNumber === 1)
              let secondWeek = json.filter(x => x.weekNumber === 2)
              let thirdWeek = json.filter(x => x.weekNumber === 3)
              let forthWeek = json.filter(x => x.weekNumber === 4)
              let fifthWeek = json.filter(x => x.weekNumber === 5)
              let sixthWeek = json.filter(x => x.weekNumber === 6)


              let first = this.sumAvg(firstWeek)
              let second = this.sumAvg(secondWeek)
              let third = this.sumAvg(thirdWeek)
              let forth = this.sumAvg(forthWeek)
              let fifth = this.sumAvg(fifthWeek)
              let sixth = this.sumAvg(sixthWeek)


              let chartData = [];

              let label = [];

              if (firstWeek.length > 0) {
                label.push('هفته اول')
                chartData.push(first)
              }

              if (secondWeek.length > 0) {
                label.push('هفته دوم')
                chartData.push(second)
              }
              if (thirdWeek.length > 0) {
                label.push('هفته سوم')
                chartData.push(third)
              }
              if (forthWeek.length > 0) {
                label.push('هفته چهارم')
                chartData.push(forth)
              }
              if (fifthWeek.length > 0) {
                label.push('هفته پنجم')
                chartData.push(fifth)
              }

              if (sixthWeek.length > 0) {
                label.push('هفته ششم')
                chartData.push(sixth)
              }


              //let slopData = [{x: 'هفته اول', y: first}]
              let slopData = [];
              if (sixth.length > 0) {
                slopData.push({x: 'هفته ششم', y: sixth})
              } else if (fifthWeek.length > 0) {
                slopData.push({x: 'هفته پنجم', y: fifth})
              } else if (forthWeek.length > 0) {
                slopData.push({x: 'هفته چهارم', y: forth})
              } else if (thirdWeek.length > 0) {
                slopData.push({x: 'هفته سوم', y: third})
              } else if (secondWeek.length > 0) {
                slopData.push({x: 'هفته دوم', y: second})
              } else if (firstWeek.length > 0) {
                slopData.push({x: 'هفته اول', y: first})
              }

              this.chartLineSlopData = slopData
              this.chartLabel = label
              this.chartAvgData = chartData
              this.hasReport = true
              this.isChartLoaded = true

            } else {
              this.hasReport = false
            }

            this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    },
    sumAvg(arr) {
      let avg = 0
      let sumMin = 0
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].Avregae > 0) {
          avg += arr[i].Avregae
          sumMin += arr[i].Minutes
        }
      }

      if (arr.length > 0) {
        return (avg / (arr.length)) * sumMin
      } else {
        return 0
      }
    },
    getLessons() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/LearnEachLesson", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.classesItems = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    loadChartData() {
      let arr = this.chartAvgData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartSlopData() {
      let arr = this.chartLineSlopData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
  }
}
</script>

<style scoped>

</style>
